import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DigitalAssistantService } from '../../../digital-assistant.service';

@Component({
  selector: 'miq-chat-input',
  templateUrl: './chat-input.component.html',
  styleUrls: ['./chat-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatInputComponent {
  @Output() sendMessage = new EventEmitter<string>();
  @Input() isResponseInProgress = false;
  @Input() message = '';
  @Output() messageChange = new EventEmitter<string>();

  private typingTimeout: any;

  onMessageChange(value: string) {
    this.message = value;

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      this.messageChange.emit(value);
    }, 500);
  }

  constructor(private chatBotService: DigitalAssistantService) {}

  send() {
    if (this.message.trim()) {
      this.sendMessage.emit(this.message);
      this.message = '';
      this.chatBotService.isPredefinedPromptSelected.set(false);
      this.chatBotService.selectedPredefinedPrompt.set('');
    }
  }

  showPromptsPanel() {
    this.chatBotService.isPromptsPanelOpen.update(prev => !prev);
    this.chatBotService.trackUserAction('Pre-defined Prompts panel opened (View All Prompts)');
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
    }
  }
}
